import Vue from 'vue';
import Vuex from 'vuex';
// import VuexPersistence from 'vuex-persist';

// Import modules here.
import CartStore from '@/store/cart';
import AuthStore from '@/store/auth';
import ShippingStore from '@/store/shipping';
import Loader from '@/store/loader';
import Search from '@/store/search';
import Account from '@/store/account';
import Order from '@/store/order';
import ListStore from '@/store/list';
import CategoryStore from '@/store/categories';
import SiteDataStore from '@/store/siteData';
import FeatureFlagStore from '@/store/featureFlags';

// const vuexLocal = new VuexPersistence({
//   storage: window.localStorage,
//   reducer: state => ({
//     cartStore: state.cartStore,
//     shippingStore: state.shippingStore,
//   }),
// });

Vue.use(Vuex);

/* This store will be used for vue-router to block user navigation,
  and will only display an error page */
const backendStore = {
  namespaced: true,
  state: {
    isBackEndAvailable: true, // In theory BackEnd is always up
    tooManyRequestsErr: false, // In theory user wont reach rate limit
    isSiteEnabled: true // In theory this site is always enabled
  },
  mutations: {
    setBackendAvailable(state, val) {
      state.isBackEndAvailable = val;
    },
    setTooManyRequestsErr(state, val) {
      state.tooManyRequestsErr = val;
    },
    setSiteEnabled(state, val) {
      state.isSiteEnabled = val;
    },
  },
  getters: {
    isBackendAvailable(state) {
      return state.isBackEndAvailable;
    },
    tooManyRequestsErr(state) {
      return state.tooManyRequestsErr;
    },
    isSiteEnabled(state) {
      return state.isSiteEnabled;
    },
  },
};

export default new Vuex.Store({
  modules: {
    backendStore,
    cartStore: CartStore,
    authStore: AuthStore,
    shippingStore: ShippingStore,
    loaderStore: Loader,
    searchStore: Search,
    accountStore: Account,
    orderStore: Order,
    listStore: ListStore,
    categoryStore: CategoryStore,
    siteDataStore: SiteDataStore,
    featureFlagStore: FeatureFlagStore
  },

  // plugins: [vuexLocal.plugin],
});
